import * as React from "react";
import * as ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import App from "./App";

import PortalApp from "./PortalApp";
import { createStore, persistor } from "./redux/lib/store";

const store = createStore("cofolp");

ReactDOM.createRoot(document.getElementById("root")!).render(
  <Provider store={store}>
    <PersistGate persistor={persistor(store)} loading={<div>Loading...</div>}>
      <React.StrictMode>
        <BrowserRouter>
          <Routes>
            <Route path="/portal/*" element={<PortalApp />} />
            <Route path="/*" element={<App />} />
          </Routes>
        </BrowserRouter>
      </React.StrictMode>
    </PersistGate>
  </Provider>
);
